import L from "lodash/fp";
import BaseContentDetailsPageNavView from "scripts/views/baseContentDetailsPageNavView";
import templateContentDetailsBookPageNav from "templates/contentDetailsBookPageNav.hbs";

class ContentDetailsBookPageNavView extends BaseContentDetailsPageNavView {
  constructor(options) {
    super(options);
    this.organizationProperties = options.organizationProperties;
    this.mediaModel = options.mediaModel;
  }

  get template() {
    return templateContentDetailsBookPageNav;
  }

  render() {
    const modelProps = this.model.toJSON();
    const mediaModelProps = this.mediaModel.toJSON();

    this.$el.html(
      this.template(
        L.merge(
          {
            hasChapters:
              mediaModelProps.mimeType ===
              "application/biblioboard+compound_content",
            showComments: !this.organizationProperties.hideCommentsTab
          },
          modelProps,
        ),
      ),
    );

    this.updateLinkState();
    this.updatePosition();

    return this;
  }
}

export default ContentDetailsBookPageNavView;
